<template>
    <readout-group-list
        :experiment="experiment"
        :abstractSchemaConfig="protocol"
        :readout-groups="readoutGroups"
        @create="createReadoutGroup"
        @update="updateReadoutGroup"
        @delete="deleteReadoutGroup"
    />
</template>
<script>
import { defineComponent } from "vue";

import { buildExperimentReadoutGroupsAPI } from "@/services/api.services";
import ReadoutGroupList from "../Measurements/ReadoutGroupList.vue";
import { withLoadingScreen } from "@/lib/loading";

export default defineComponent({
    components: { ReadoutGroupList },

    props: {
        readoutGroups: {
            type: Array,
            required: true,
        },
        protocol: {
            type: Object, // AbstractSchemaConfig
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            experimentReadoutGroupsAPI: null,
        };
    },

    mounted() {
        this.experimentReadoutGroupsAPI = buildExperimentReadoutGroupsAPI(this.experiment.code);
    },

    methods: {
        createReadoutGroup(readoutGroup) {
            return this.save(() => this.experimentReadoutGroupsAPI.create(readoutGroup));
        },
        updateReadoutGroup(readoutGroup) {
            return this.save(() => this.experimentReadoutGroupsAPI.update(readoutGroup));
        },
        async save(saveFn) {
            return withLoadingScreen(async () => {
                const savedReadoutGroup = await saveFn();
                this.$emit("saved", savedReadoutGroup);
            });
        },
        async deleteReadoutGroup(readoutGroup) {
            return withLoadingScreen(async () => {
                await this.experimentReadoutGroupsAPI.delete(readoutGroup.id);
                this.$emit("deleted", readoutGroup);
            });
        },
    },
});
</script>
<style></style>
